export enum Permission {
    CanAccessUserManagement = 'Can Access User Management',
    CanAccessAnnouncementManagement = 'Can Access Announcement Management',
    CanAccessQualityAudit = 'Can Perform Quality Audit'
}